import React from 'react';
import { Plus, Trash2 } from 'lucide-react';
import { UsersThree } from '@phosphor-icons/react';
import AppIcon from '../AppIcon';
import PhotoUploader from '../PhotoUploader';

const inp = 'px-3 py-2 rounded-lg border border-[#EFE3D8] text-sm bg-white';

export const GroupGiftsEditor = ({ cfg, setCfg, save, saving }) => {
  const list = cfg.group_gifts || [];
  const set = (i, patch) => { const next = [...list]; next[i] = { ...list[i], ...patch }; setCfg({ ...cfg, group_gifts: next }); };
  return (
    <section data-testid="group-gifts-editor" className="soft-card bg-white rounded-2xl border border-[#EFE3D8] p-5">
      <div className="flex items-center gap-3 mb-3">
        <AppIcon icon={UsersThree} tone="lavender" size="md" reveal />
        <div>
          <h2 className="font-serif text-xl">Group gifts</h2>
          <p className="text-xs text-[#6A6A6A]">Big-ticket items guests can chip in on together. A progress bar shows how close you are. Anything over the price comes to you as cash.</p>
        </div>
      </div>
      {list.map((g, i) => (
        <div key={g.id || i} data-testid={`group-gift-${i}`} className="mb-4 p-3 rounded-xl border border-[#EFE3D8] bg-[#FBF7F2] grid grid-cols-1 md:grid-cols-[minmax(0,1fr)_240px] gap-3">
          <div className="space-y-2">
            <input data-testid={`group-gift-title-${i}`} value={g.title || ''} onChange={(e) => set(i, { title: e.target.value })} placeholder="e.g. KitchenAid stand mixer" className={`${inp} w-full`} />
            <textarea value={g.description || ''} onChange={(e) => set(i, { description: e.target.value })} rows={2} placeholder="Why you'd love it…" className={`${inp} w-full`} />
            <div className="grid grid-cols-3 gap-2">
              <input data-testid={`group-gift-price-${i}`} type="number" min="1" value={g.price_cents ? g.price_cents / 100 : ''} onChange={(e) => set(i, { price_cents: e.target.value ? Math.round(parseFloat(e.target.value) * 100) : null })} placeholder="Price" className={inp} />
              <select value={g.currency || 'usd'} onChange={(e) => set(i, { currency: e.target.value })} className={inp}><option value="usd">USD</option><option value="cad">CAD</option></select>
              <input value={g.url || ''} onChange={(e) => set(i, { url: e.target.value })} placeholder="Product link (optional)" className={inp} />
            </div>
            <button data-testid={`group-gift-delete-${i}`} onClick={() => save({ group_gifts: list.filter((_, x) => x !== i) })} className="text-[11px] text-[#B8896C] hover:text-[#7B2C3B] inline-flex items-center gap-1"><Trash2 className="w-3 h-3" /> Remove</button>
          </div>
          <div className="min-w-0 overflow-hidden"><PhotoUploader value={g.photo} onChange={(url) => set(i, { photo: url })} testId={`group-gift-photo-${i}`} label="Photo" aspect="square" /></div>
        </div>
      ))}
      <div className="flex items-center gap-3">
        <button data-testid="registry-add-group-gift" onClick={() => setCfg({ ...cfg, group_gifts: [...list, { title: '', currency: 'usd' }] })} className="text-xs px-3 py-1.5 rounded-full border border-[#EFE3D8] hover:bg-[#F6EAE0] inline-flex items-center gap-1"><Plus className="w-3 h-3" /> Add group gift</button>
        <button data-testid="registry-save-group-gifts" onClick={() => save({})} disabled={saving} className="text-xs px-4 py-1.5 rounded-full btn-primary disabled:opacity-50">{saving ? 'Saving…' : 'Save changes'}</button>
      </div>
    </section>
  );
};

export default GroupGiftsEditor;
